@if (shouldShowBanner && hasTimeCards) {
  <span id="reportedTimecardStatus">
    Your start date is in the future. Some actions are unavailable
  </span>
}